<template>
    <div class="logistics-home">
        <!-- 头部导航 -->
        <headerBlack-view></headerBlack-view>
        <!-- 主体内容 -->
        <div class="logistics-home-container">
              <div class="logistics-banner">
                <div class="logistics-banner-wrapper main">
                    <h2 class="title">1+X后勤管理与职业教育系统</h2>
                    <p class="introduce">保障智慧后勤管理与应用职业技能等级证书试点工作顺利开展，实现标准化教学，提升试点院校教师的实践教学能力，
                        促进标准与专业教学标准衔接与融通。</p>
                </div>
              </div>
              <div class="sub-navigate">
                  <ul class="sub-nav-ul main flex-layout">
                        <li v-for="(item,index) in navigate" 
                            :key="index" 
                            :class="{'active': active == index + 1}"
                            @click="handleClick(item,index)"
                            class="csp">
                            {{item.name}}
                        </li>
                  </ul>
              </div>
              <router-view :columnId="currentColumnId"></router-view>
        </div>
        <footer-view></footer-view>
  </div>
</template>

<script>
export default {
    data() {
        return {
            navigate:[ //导航list
                // {   
                //     name:'精品课程',
                //     path:'subject'
                // },
                // {
                //     name:'专家团队',
                //     path:'expert'
                // },
                // {   
                //     name:'项目案例',
                //     path:'project'
                // },
                // {
                //     name:'证书查询',
                //     path:'certificate'
                // }
            ],
            active:1, //当前被选中的导航
            currentColumnId:0,
        }
    },
    watch:{},
    methods: {
        handleClick(item,index) {
            this.active = index + 1;
            sessionStorage.setItem('wsActive',index+1);
            this.currentColumnId = item.id
            this.$nextTick(function(){
                this.$router.push(item.path);
            })
           
        },
        async getColumnLsit() {
            let id = 109  //90是1+x
            let resData = await Api.Wisdom.getColumnLsit(id)
            // console.log(resData)       
            this.navigate = resData.data
            this.currentColumnId = this.navigate[0].id
        },
        init() {
            if(sessionStorage.getItem('wsActive')) {
                this.active = sessionStorage.getItem('wsActive')
            } else {
                let xPath = window.location.href.split('/')[window.location.href.split('/').length - 1];
                this.navigate.map((item,index)=>{
                    if(item.path === xPath) {
                        this.active = index + 1
                        sessionStorage.setItem('wsActive',this.active);
                    }
                    
                })
            }
        }
    },
    created() {
         sessionStorage.setItem('projectID',109);
    },
    mounted() {
        this.getColumnLsit();
        this.init();
    },
    destroyed() {
        sessionStorage.removeItem('wsActive')
    }
}
</script>

<style lang="less" scoped>
    @import "../wisdom/less/wisdom_home.less";
</style>